import {
  createUnitTypeOptions,
  WORKING_DECLARATION_LABEL_KEYS,
  UNIT_TYPES,
} from '@/config/unitTypes.constants';

// A ledger row carries its quantity and balance in all three units.
export const { unitTypeLabel, buildRowUnitOptions, buildUnitHeaderOptions } = createUnitTypeOptions(
  {
    ...WORKING_DECLARATION_LABEL_KEYS,
    [UNIT_TYPES.tracking]: 'UNIT_TRACKING',
  },
);
